const ResourceTitle = ({ record }) => {
    return <span>Resource {record ? `"${record.name}"` : ''}</span>;
};

export default ResourceTitle;